module.exports = __webpack_public_path__ + "img/polotitlan.58c3da9f.jpg";